import api from "../../../api";

// ✅ Récupérer les partenaires actifs
export const getPartenaires = async () => {
  try {
    const res = await api.get("/partenaires");
    return res.data.partenaires.filter(p => !p.archived) || [];
  } catch (err) {
    console.error("Erreur API :", err);
    return [];
  }
};

// ✅ Récupérer les partenaires archivés
export const getArchives = async () => {
  try {
    const res = await api.get("/partenaires");
    return res.data.partenaires.filter(p => p.archived) || [];
  } catch (err) {
    console.error("Erreur API Archives :", err);
    return [];
  }
};

// ✅ Ajouter un nouveau partenaire
export const ajouterPartenaire = async (data) => {
  try {
    await api.post("/partenaires", data);
  } catch (err) {
    console.error("Erreur ajout partenaire :", err);
  }
};

// ✅ Archiver / Désarchiver un partenaire
export const toggleArchivePartenaire = async (id, archived) => {
  try {
    await api.put(`/partenaires/${id}`, { archived: !archived });
  } catch (err) {
    console.error("Erreur archivage/désarchivage :", err);
  }
};